import Toggle from '../Toggle';
export default function ConversationsHeaderToggle({ checked, onChange }: { checked: boolean; onChange: (value: boolean) => void }) {
  return <label className="mr-3 flex cursor-pointer items-center gap-2 whitespace-nowrap text-xs font-medium text-white/90" onPointerDown={e => e.stopPropagation()} onClick={e => e.stopPropagation()}>
    Show resolved
    <Toggle size="xs" checked={checked} onChange={onChange} ariaLabel="Show resolved" />
  </label>;
}
